import { jsx as o } from "@emotion/react/jsx-runtime";
import i from "prop-types";
import { useTheme as l } from "../../theme.mjs";
const p = ({ fill: e, ...r }) => {
  const t = l();
  return /* @__PURE__ */ o(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: e || t.colors.foreground,
      ...r,
      children: /* @__PURE__ */ o(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 0.999999 12 0.999999C18.0751 1 23 5.92487 23 12ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM11 17L11 11L13 11L13 17L11 17ZM11 8C11 7.44771 11.4477 7 12 7C12.5523 7 13 7.44771 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8Z"
        }
      )
    }
  );
};
p.propTypes = {
  fill: i.string
};
export {
  p as Info
};
